import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import RecordContainer from "../../components/Record/RecordContainer";
import { parsedUser } from "../../common/GetCurrentUser";
import { Routes } from "../../routes";

const BackgroundCheckReportPage = () => {
    const history = useHistory();
    const user = parsedUser();

    useEffect(() => {
        if (!user) {
            history.push(Routes.SignIn.path);
        }
    }, [user]);

    if (!user) {
        return null;
    }

    document.title = window.location.href.includes("backgroundcheck")
        ? "Background Check"
        : "Data Worker"
    return <RecordContainer backgroundCheck={true} />
}

export default BackgroundCheckReportPage;
